import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { getAsset } from '../../../../../../util/assets';
import Button from '../../../../../../components/global/Button';

const propTypes = {
  albumFolder: PropTypes.shape({
    id: PropTypes.string.isRequired,
    web_app_urls: PropTypes.shape({
      onboarding_url: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
};

const WebGalleryUpsellBannerPFContent = ({ albumFolder }) => {
  const url = new URL(albumFolder?.web_app_urls?.onboarding_url ?? '');
  url.searchParams.append('utm_source', 'btn_fwg_upsell_upload_selfie');

  return (
    <Fragment>
      <img
        className="web-gallery-upsell-content-img"
        src={getAsset('/waldo_alone_cropped.png')}
        alt=""
      />

      <div className="web-gallery-upsell-content-copy">
        <h4>Let me help you find all your photos!</h4>
        <p>Upload your selfie and see the photos you appear in.</p>
      </div>

      <div className="web-gallery-upsell-content-actions">
        <Button
          btnSize="sm"
          id="btn_fwg_upsell_upload_selfie"
          href={url.href}
          target="_blank"
        >
          Upload Selfie
        </Button>
      </div>
    </Fragment>
  );
};

WebGalleryUpsellBannerPFContent.propTypes = propTypes;

export default WebGalleryUpsellBannerPFContent;
